import { appidJsapiSign, AppidJsapiSignReq } from '@tencent/wphk-act-base-cgi';
import { to, url, userEnv } from '@tencent/wphk-base-utils';
import { wxBridge, WxMpShareInfo, WxShareInfo } from '@tencent/wphk-base-wx';
import { getLoginToken } from '@tencent/wphk-act-base-api';
import { IWxInitParams } from '@tencent/wphk-base-wx/dist/types';

/**
 *  获取jspai查询参数
 * @returns
 */
function getAppidJsapiSignReq() {
  const params: AppidJsapiSignReq = {
    url: location.href.split('#')[0],
    appName: 'hk_life',
    loginToken: '',
    passTicket: url.getUrlParam('pass_ticket') || '',
  };
  try {
    params.loginToken = getLoginToken() || '';
  } catch (error) {
  }
  return params;
}


/**
 *  微信初始化
 * @param options 初始化jsapi相关参数选项
 * @returns
 */
export function setUpWeixin(options?: Pick<IWxInitParams, 'apiList'| 'openTagList'>) {
  return wxBridge.weiXinInit({
    apiList: options?.apiList,
    // TODO: 暂时先写死这两个
    openTagList: options?.openTagList || ['wx-open-launch-weapp', 'wx-open-subscribe'],
    getTicket: async () => {
      const parms = getAppidJsapiSignReq();
      const [err, data] = await to(appidJsapiSign(parms));
      if (err || !data) return {} as any;
      const { appId, nonceStr, signature, timestamp } = data;
      return {
        appId,
        nonceStr,
        signature,
        timestamp,
      };
    },
  });
}

/**
 * 设置微信分享内容
 * @param link 原链接 + 分享码 + adtag
 */
export function setWxShareInfo(info: { wx?: WxShareInfo, mp?: WxMpShareInfo }) {
  const isInMp = userEnv.isInMiniProgram();
  if (isInMp) {
    // 设置小程序分享信息
    !!info.mp && wxBridge.setMpShareInfo(info.mp);
  } else {
    // 设置 h5 分享信息
    !!info.wx && wxBridge.setShareInfo(info.wx);
  }
}
